const updatesObject = {
    prev: { grps: {}, rows: {} },
    next: { grps: {}, rows: {} }
};
export default updatesObject;